import { Button, Table,Spin, Tag, SelectProps, Select} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import {AUTH_URL} from '../constants';
import { TfiReload } from 'react-icons/tfi';
import {IClient, ILoanFine} from '../factory/interfaces'
import { IoMdArrowDropright } from 'react-icons/io';
import { notify, toastStyle } from '../pages/LoginPage';
import Search from 'antd/es/input/Search';
import { IoPersonCircleOutline } from 'react-icons/io5';



const Finestable = () => {
    const [fines, setFines] = useState<ILoanFine[]>()
    const [filteredFines, setFilteredFines] = useState<ILoanFine[] | undefined>(fines)
    const [searchQuery, setSearchQuery] = useState<string>('')
    const [clients, setClients] = useState<IClient[]>([])
    const [filteredClients, setFilteredClients] = useState<IClient[] | undefined>(clients)
    const [marchedClient, setMarchedClient]= useState<string | null>()


    //Functions

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: 'client',
  },
   {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
  },
  {
    title: 'Old Balance',
    dataIndex: 'old_balance',
    key: 'old_balance',
  },
  {
    title: 'Fine Amount',
    dataIndex: 'fine_amount',
    key: 'fine_amount',
  },
  {
    title: 'New Balance',
    dataIndex: 'new_balance',
    key: 'new_balance',
  },
  {
    title: 'Client notified',
    dataIndex: 'notified',
    key: 'notified',
    render: (text: string, record: ILoanFine)=> <Tag color={record.notified ? 'green' : 'magenta'}>
      {record.notified ? 'YES': 'NO'}
    </Tag>
  },
  {
    title: 'Loan Ended On',
    dataIndex: 'loan_end_date',
    key: 'loan_end_date',
  },
  {
    title: 'Date of fine',
    dataIndex: 'fine_date',
    key: 'fine_date',
  },
   {
    title: 'Payment Status',
    dataIndex: 'paid',
    key: 'paid',
    render: (text: string, record: ILoanFine)=> <Tag color={record.paid ? 'green' : 'red'}>
      {record.paid ? 'PAID': 'NOT PAID'}
    </Tag>
  },

]

    const getLoanFines = async()=>{
      try {
        const response = await axios.get(`${AUTH_URL}/finances/loans/fines`, {params: {client: marchedClient},withCredentials: true})
        if(response.data.success){
          setFines(response.data.fines)
        }else{
        notify(response.data.message, toastStyle)
          setFines([])
        }
        
      } catch (error: any) {
        notify(error.message, toastStyle)
      }
    }

    const getClientNames = async()=>{
      try {
        const response = await axios.get(`${AUTH_URL}/clients/names`, {withCredentials: true})
        if(response.data.success){
          setClients(response.data.clients)
        }else{
        notify(response.data.message, toastStyle)
          setClients([])
        }
        
      } catch (error: any) {
        notify(error.message, toastStyle)
      }
    }

  useEffect(()=>{
    getLoanFines()
    getClientNames()
  }, [])

  useEffect(() => {
    getLoanFines()
  }, [marchedClient])


  useEffect(() => {
    if (marchedClient?.trim() === '') {
      setFilteredFines(fines)
    } else {
      setFilteredClients(
        clients?.filter((client: any) =>
          client.name.toLowerCase().includes(searchQuery.toLowerCase())
        )
      )
    }
  }, [searchQuery, clients])


  const handleSearchCattleNames = (newValue: string) => {
    setSearchQuery(newValue)
  }

  return (
    <>
    {fines? 
    <>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Loan Fines</h4>
         </Col>
         <Col className='text-end py-2 d-flex justify-content-end'>
          <Button type='link' className='rounded-4 border mx-2' icon={<IoPersonCircleOutline />}> CLIENT FILTER
              <Select
                showSearch
                placeholder="Enter name, or phone of client to search"
                defaultActiveFirstOption={false}
                suffixIcon={null}
                filterOption={false}
                onSearch={handleSearchCattleNames}
                notFoundContent={null}
                options={(filteredClients || []).map((client: any) => ({
                  value: client._id,
                  label: client.name,
                }))}
                allowClear
                onChange={setMarchedClient}
                className='rounded-4 border-0 mx-2'
                style={{
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                  borderRight: '0'
                }}
              />
            </Button>
            <Button  className='rounded-0' type="dashed"> <TfiReload/> <span className='mx-1'>Reload</span></Button>
         </Col>
            
        </Row>
    
     {
      fines &&
      <Table className='rounded-0 transactions-table' id='dlms-expenses-data' bordered dataSource={fines} columns={columns} 
       />
     }
     
      </> : 
        <Spin style={{paddingTop: 100}} tip="Loading fines..." size="large">
        <div className="content" />
      </Spin>

    }
   
    </>
  )
}

export default Finestable